import { observer } from 'mobx-react';
import React from 'react';
import {
  Box, Button,
  Text,
  TextButton,
  TextButtonSize,
  TextButtonWeight,
} from '@wix/design-system';
import { useTranslation } from 'react-i18next';

export interface ResendVerificationCodeProps {
  resendSuccessfullyIndication: boolean;
  resendThrottleTimerValue: number;
  sendConfirmationCode: () => void;
  resendErrorMessage?: string | null;
  resendButtonTranslationKey?: string;
  resendIndicationTranslationKey: string;
  resendButtonSize: TextButtonSize;
  resendButtonWeight?: TextButtonWeight;
  showAsButton?: boolean;
}

export const ResendVerificationCode: React.FC<ResendVerificationCodeProps> =
  observer(
    ({
      resendSuccessfullyIndication,
      resendThrottleTimerValue,
      resendErrorMessage,
      sendConfirmationCode,
      resendButtonTranslationKey,
      resendIndicationTranslationKey,
      resendButtonSize,
      resendButtonWeight,
      showAsButton,
    }) => {
      const { t } = useTranslation();
      return (
        <Box direction="horizontal" gap={1}>
          {!resendSuccessfullyIndication && !showAsButton && (
            <TextButton
              size={resendButtonSize}
              weight={resendButtonWeight}
              onClick={sendConfirmationCode}
            >
              {t(
                resendButtonTranslationKey ??
                  'confirmEmailModalSecondStep.confirmationCode.resendLink.text',
              )}
            </TextButton>
          )}
          {!resendSuccessfullyIndication && showAsButton && (
            <Button onClick={sendConfirmationCode} priority={'secondary'} size={'small'}>
              {t(
                resendButtonTranslationKey ??
                  'confirmEmailModalSecondStep.confirmationCode.resendLink.text',
              )}
            </Button>
          )}
          {resendSuccessfullyIndication && (
            <Text
              size={resendButtonSize}
              weight={"thin"}
              light
              secondary
            >
              {t(resendIndicationTranslationKey, {
                time: resendThrottleTimerValue.toString(),
              })}
            </Text>
          )}
          {resendErrorMessage && (
            <Box inline marginLeft={1}>
              <Text skin="error" size="small">
                {resendErrorMessage}
              </Text>
            </Box>
          )}
        </Box>
      );
    },
  );
